export default __webpack_public_path__ + "static/media/back.900f1f31.svg";